export { default } from './LineTabs';
export { default as LineTabs } from './LineTabs';
export type { LineTabType } from './LineTabs';
